export default __webpack_public_path__ + "static/media/boxHighlight.40980bc7.svg";